export default "__VITE_ASSET__Cde3avFh__"